module.exports = __webpack_public_path__ + "images/facilicom_smalle0377c180fc14d719ee7365a63fa8283.png";